import React from 'react';
import chaticon from "../../../assets/img/Group 6356.svg"
import QuickAddMenu from './NavbarComponents/QuickAddMenu/QuickAddMenu';
import History from './NavbarComponents/History/History';
import GlobalInstantSearch from './NavbarComponents/GlobalInstantSearch/GlobalInstantSearch';
import Notifications from './NavbarComponents/Notifications/Notifications';
import NavTasks from './NavbarComponents/NavTasks/NavTasks';
import Cookies from "js-cookie";
import PracticeName from './NavbarComponents/PracticeName/PracticeName';
import { isChildWindow } from '../../../utils/Constants';
import Logostar from '../../../assets/img/logox.svg'
import Draggable from 'react-draggable';
import { useSelector } from 'react-redux';
const Navbar = () => {
    ////==== hide navbar content in case of sub browser tab ====////
    // const navbarContent = document.getElementById('NavbarContentItems');
    // if (navbarContent && Cookies.get('browserNewTabContent')) {
    //     navbarContent.classList.add("d-none");
    // }
    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            <div className="header">
                {/* {isLoading ? <Loader /> : null} */}
                <div className="header-container">
                    <PracticeName />
                    <div className="d-flex gap-2 align-items-center"><div className="d-flex align-items-center gap-3 position-relative">
                        {!isChildWindow &&
                            <div id='NavbarContentItems' className="d-flex align-items-center gap-3 position-relative">
                                <NavTasks />
                                {/* <div className="alert-icon session-btn app_tooltip bottom"  >
                                    <img src={chaticon} ></img>
                                    <p class="tool_tip xsm_text text-light">Messages</p>
                                    <span className="count">1</span>
                                </div> */}
                                <QuickAddMenu />
                                <History />
                                <Notifications />
                                <GlobalInstantSearch />
                            </div>}
                    </div>
                        <a href={ThemeConfiguration?.configuration?.company?.websiteUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            <div className="user-logo za-user-logo d-flex align-items-end gap-1 pe-1" href="https://starhealthcare.co/">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/logox.svg"} alt="" /> */}
                                <img src={Logostar} alt="" />
                                <div className='d-flex flex-column'>
                                    <span className='za_STAR fs-11 fw-900 fst-normal drk-green-clr'>S<span className='orange-logo-clr'>T</span>AR</span>
                                    <span className='za_health_logo text-nowrap fs-10 fst-italic fw-900 br-bottom-1 orange-logo-clr'>Healthcare Technologies</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className='overlay'></div>
                {/* <Draggable handle=".ar_ai-encounter-button" defaultPosition={{ x: 1205, y: 153 }}>
                    <div className="ar_ai-encounter-button  position-fixed z-index-999">
                        <div className="ai-enable-encounter flex-center rounded-5 position-static">
                            <i className='icon-ai-encounter fs-18'></i>
                        </div>
                    </div>
                </Draggable> */}

            </div>
        </>
    )
}
export default Navbar;